import { makeStyles } from "@material-ui/core"

const useStyles = makeStyles(() => ({
    graphic: {
        width: '100%',
        height: '400px',
        background: 'white',
        borderRadius: 12,
        padding: 12
    }

}))

export default useStyles